<ta-lcl-auth-container>
  <div *ngIf="!submitted">
    <ta-flexbox justifyContent="center" class="w--100 pb--3">
      <h1 class="heading--1">Reset your password</h1>
    </ta-flexbox>

    <p class="pb--3">
      Enter your email address below and we'll send you instructions on how to
      change your password.
    </p>

    <div class="pb--3">
      <ta-form-field
        label="Email"
        [errors]="validationResult?.errors?.nested?.email"
        [forceShowErrors]="forceShowErrors"
        [dirty]="forgotPasswordForm.get('email')?.dirty"
        [uppercaseLabel]="true"
      >
        <ta-input
          type="email"
          [formControl]="forgotPasswordForm.get('email')"
        ></ta-input>
      </ta-form-field>
    </div>

    <ta-flexbox alignItems="center" justifyContent="space-between">
      <ta-link
        routerLink="/login"
        [queryParams]="{
          email: forgotPasswordForm.value.email,
          method: 'tapad',
          redirect: redirect
        }"
        [class.disabled]="loading"
        >
          <ta-icon icon="left-big"></ta-icon> Back to login
        </ta-link
      >

      <ta-button
        priority="primary"
        type="submit"
        (taInteract)="submitForm()"
        [disabled]="loading"
      >
        <ng-template [ngIf]="!loading"> Send Email </ng-template>
        <ng-template [ngIf]="loading">
          Sending Email <ta-icon icon="spinner" spin></ta-icon>
        </ng-template>
      </ta-button>
    </ta-flexbox>
  </div>

  <div *ngIf="submitted">
    <div class="header header--center">We sent you an email.</div>

    <div class="section section--padding-h">
      You will receive an email at
      <strong class="weight--bold">{{ forgotPasswordForm.value.email }}</strong>
      with instructions to reset your password.
    </div>
  </div>
</ta-lcl-auth-container>
